import ElButton from './src/button';

/* istanbul ignore next */
ElButton.install = function(Vue) {
  Vue.component(ElButton.name, ElButton);
};

export default ElButton;



//////////////////
// WEBPACK FOOTER
// ./~/element-ui/packages/button/index.js
// module id = UUUu
// module chunks = 144